var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floatingButton",style:(_vm.backgroundColor)},[_c('div',{staticClass:"button",on:{"click":function($event){return _vm.$emit('validate')}}},[_c('v-icon',{attrs:{"font-size":"3em"}},[_vm._v(_vm._s(_vm.icon))])],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-container"},[_c('div',{staticClass:"label-text"},[_vm._v("Envoyer")])])
}]

export { render, staticRenderFns }